import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { GlobalPrimaryHeaderComponent } from "./global-primary-header/global-primary-header.component";
import { GlobalMenuComponent } from "./global-menu/global-menu.component";
import { IconsModule } from "@va/core-library/icons";
import { GlobalSearchComponent } from "./global-search/global-search.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NzRadioModule } from "ng-zorro-antd/radio";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzBadgeModule } from "ng-zorro-antd/badge";
import { NzListModule } from "ng-zorro-antd/list";
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzPopoverModule } from "ng-zorro-antd/popover";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzButtonModule } from "ng-zorro-antd/button";
import { MatTabsModule } from "@angular/material/tabs";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { GlobalUserMenuComponent } from "./global-user-menu/global-user-menu.component";
import { AddinUserSettingsModalComponent } from "./addin-user-settings-modal/addin-user-settings-modal.component";
import { GlobalSsoMenuComponent } from "./global-sso-menu/global-sso-menu.component";
import { GlobalFooterComponent } from "./global-footer/global-footer.component";
import { GlobalNotificationComponent } from "./global-notification/global-notification.component";
import { SharedModule } from "../shared/shared.module";
import { NotificationRendererModule } from "../shared/notification-renderer/notification-renderer.module";
import { GlobalUserSettingsComponent } from "./global-user-settings/global-user-settings.component";
import { OverlayModule } from "@angular/cdk/overlay";
import { NzTabsModule } from "ng-zorro-antd/tabs";

import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
@NgModule({
  declarations: [
    GlobalPrimaryHeaderComponent,
    GlobalMenuComponent,
    GlobalSearchComponent,
    GlobalUserMenuComponent,
    AddinUserSettingsModalComponent,
    GlobalSsoMenuComponent,
    GlobalFooterComponent,
    GlobalNotificationComponent,
    GlobalUserSettingsComponent,
  ],
  imports: [
    RouterModule,
    CommonModule,
    IconsModule,
    FormsModule,
    ReactiveFormsModule,
    NzRadioModule,
    NzDropDownModule,
    NzSkeletonModule,
    NzBadgeModule,
    NzListModule,
    NzLayoutModule,
    NzModalModule,
    NzInputModule,
    NzGridModule,
    NzToolTipModule,
    NzPopoverModule,
    NzCheckboxModule,
    NzButtonModule,
    MatTabsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    OverlayModule,
    NzTabsModule,

    SharedModule,
    NotificationRendererModule,
  ],
  exports: [
    GlobalPrimaryHeaderComponent,
    GlobalFooterComponent,
    GlobalUserSettingsComponent,
  ],
})
export class GlobalHeaderModule {}
